import type { FC } from 'react';
import { useIntl } from 'react-intl';

import { Typography } from '@/components/Typography';
import type { WithdrawalCode } from '@/lib/withdrawal/types';
import * as PM from '@/messages/payment';

export type WithdrawalCtaFootnotesProps = {
  showReturnPolicyFootnote: boolean;
  withdrawalCode: WithdrawalCode | null;
};

export const WithdrawalCtaFootnotes: FC<WithdrawalCtaFootnotesProps> = ({
  showReturnPolicyFootnote,
  withdrawalCode,
}) => {
  const { formatMessage } = useIntl();

  return (
    <>
      {withdrawalCode === 'WINDOW_EXPIRED' && (
        <Typography
          color='secondaryGrey'
          marginTop={1}
          scale='p3'
          textAlign='center'
        >
          {formatMessage(PM.paymentMessages.withdrawalWindowExpired)}
        </Typography>
      )}
      {withdrawalCode === 'DUPLICATE_REQUEST' && (
        <Typography
          color='secondaryGrey'
          marginTop={1}
          scale='p3'
          textAlign='center'
        >
          {formatMessage(PM.paymentMessages.withdrawalDuplicateRequest)}
        </Typography>
      )}
      {showReturnPolicyFootnote ? (
        <Typography
          color='secondaryGrey'
          marginTop={1}
          scale='p3'
          textAlign='center'
        >
          {formatMessage(PM.paymentMessages.returnPolicyFootnote)}
        </Typography>
      ) : null}
    </>
  );
};
